import { render, staticRenderFns } from "./ReturnSend.vue?vue&type=template&id=5a1d8961&scoped=true"
import script from "./ReturnSend.vue?vue&type=script&lang=js"
export * from "./ReturnSend.vue?vue&type=script&lang=js"
import style0 from "./ReturnSend.vue?vue&type=style&index=0&id=5a1d8961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d8961",
  null
  
)

export default component.exports